import { api } from './api';

export type ActionTone = 'urgent' | 'recommended' | 'suggested';

export interface NextAction {
  key: string;
  tone: ActionTone;
  title: string;
  rationale: string;
  cta: string;
  path: string;
  icon: string;
  count?: number;
  params?: Record<string, string | number>;
  priority: number;
}

export interface NextActionsResult {
  actions: NextAction[];
  allCaughtUp: boolean;
}

export const nextActionsApi = {
  get: (wsId: string): Promise<NextActionsResult> =>
    api.get(`/api/workspaces/${wsId}/next-actions`).then((r) => r.data),
};
